import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { ProjectCard } from '@/components/ui/ProjectCard';
import { SectionHeader } from '@/components/ui/Primitives';
import { Stagger, StaggerItem } from '@/components/ui/Reveal';
import { complexityTotal } from '@/components/ui/Complexity';
import type { Project } from '@/lib/types';
import { useI18n } from '@/store/preferences';

export function SelectedWork({ projects }: { projects: Project[] }) {
  const { t } = useI18n();

  const showcase = projects
    .filter((project) => project.scale === 'MAJOR')
    .sort((a, b) => {
      const load = (project: Project) =>
        project.complexity ? complexityTotal(project.complexity) : 0;
      return load(b) - load(a);
    })
    .slice(0, 4);

  if (showcase.length === 0) return null;

  return (
    <section className="section" id="work">
      <div className="shell">
        <SectionHeader
          eyebrow={t.sections.selectedWork}
          title={t.sections.selectedWorkTitle}
          action={
            <Link to="/projects" className="btn-outline group">
              {t.sections.allProjects}
              <ArrowRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-0.5" />
            </Link>
          }
        />

        <Stagger className="grid gap-5 lg:grid-cols-2">
          {showcase.map((project, index) => (
            <StaggerItem key={project.id} index={index} className="h-full">
              <ProjectCard project={project} />
            </StaggerItem>
          ))}
        </Stagger>
      </div>
    </section>
  );
}
